import { useEffect } from "react";
import { useMatches, useRouteError } from "react-router-dom";

console.warn("[RouteErrorBoundary] module loaded");

export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const matches = useMatches();
  const err = error as { message?: string; stack?: string; status?: number };

  console.error("[RouteErrorBoundary] CAUGHT ROUTE ERROR", {
    url: window.location.pathname + window.location.search,
    message: err?.message,
    status: err?.status,
    error,
    stack: err?.stack,
    matchedRoutes: matches.map((m) => ({
      id: m.id,
      pathname: m.pathname,
      params: m.params,
    })),
  });

  useEffect(() => {
    console.trace("[RouteErrorBoundary] render trace");
  }, []);

  return (
    <div
      data-testid="route-error-boundary"
      style={{
        padding: 24,
        background: "#b91c1c",
        color: "white",
        fontFamily: "monospace",
        border: "4px solid yellow",
      }}
    >
      <h2 style={{ margin: 0 }}>🔴 RouteErrorBoundary caught an error</h2>
      <pre style={{ marginTop: 12, whiteSpace: "pre-wrap" }}>
        message: {err?.message ?? "(none)"}
        {"\n"}status: {err?.status ?? "(none)"}
        {"\n"}url: {window.location.pathname + window.location.search}
      </pre>
    </div>
  );
};
